export const actionTypes = {
  success: '[Notify] Success',
  error: '[Notify] Error',
};

export const success = (msg) => ({
  type: actionTypes.success,
  msg
});

export const error = (msg) => ({
  type: actionTypes.error,
  msg
});

export const actions = {
  success,
  error,
};



// WEBPACK FOOTER //
// ./src/components/ui/Notify/store/actions.js